import { Link } from "react-router-dom";
import { Button, Collapse, Container, Navbar } from "reactstrap";


function TopRangeNavbarSimple () {

  const NavBarOpenButton = () => 
    <Button color="danger" className="btn-link navbar-toggler" href={'/index'} outline>
      <i className="nc-icon nc-minimal-left" />
    </Button>

  return (
    <Navbar
      className="fixed-top navbar-light"
      color-on-scroll="300"
      expand="lg"
    >
      <Container >
        <div className="navbar-translate">
          <Link to={'/index'}>
            <img alt="TopRange" src={require("../assets/img/tr_logo_v.png")} height={100} />
          </Link>
          <NavBarOpenButton />
        </div>
        <Collapse navbar className="justify-content-end">
          <Button color="danger" className="btn-link" href={'/index'} outline>
            На главную страницу
          </Button>
        </Collapse>
      </Container>
    </Navbar>
  )
}

export default TopRangeNavbarSimple;